import { MobileBackButton, MobileHeader } from '@/components/mobile';
import { cn } from '@/lib/utils';

const BUBBLES = [
	{ side: 'left', width: 'w-3/5' },
	{ side: 'right', width: 'w-1/2' },
	{ side: 'left', width: 'w-2/3' },
	{ side: 'right', width: 'w-2/5' },
	{ side: 'left', width: 'w-1/2' },
];

/**
 * What a phone shows while an opened conversation is still loading (a deep
 * link, a push notification): the thread's shape and a working back button,
 * instead of an empty screen.
 */
export function MobileThreadPlaceholder({ title = 'Loading…', onBack, className }) {
	return (
		<div className={cn('absolute inset-0 z-20 flex flex-col bg-background md:hidden', className)} aria-busy="true">
			<MobileHeader title={title} left={<MobileBackButton onClick={onBack} />} />
			<div className="flex flex-1 flex-col justify-end gap-3 overflow-hidden px-4 pb-6" aria-hidden="true">
				{BUBBLES.map((bubble, i) => (
					<div
						key={i}
						className={cn(
							'h-10 animate-pulse rounded-2xl bg-muted',
							bubble.width,
							bubble.side === 'right' && 'self-end bg-primary/10',
						)}
					/>
				))}
			</div>
			<div className="shrink-0 border-t border-border/60 px-3 pb-safe pt-2">
				<div className="mb-2 h-11 animate-pulse rounded-full bg-muted" aria-hidden="true" />
			</div>
		</div>
	);
}
